import {
  usePaginatedResource,
  useResourceItem,
  useCreateResource,
  useEditResource,
  useDeleteResource,
} from "./useCrudResource"

import {
  getCarCareServiceCenters,
  getCarCareServiceCenter,
  createCarCareServiceCenter,
  updateCarCareServiceCenter,
  deleteCarCareServiceCenter,
} from "api/carCareServiceCenterApi"

export const CAR_CARE_SERVICE_CENTER_QUERY_KEY = "car-care-service-centers"

// -------------------- FETCH PAGINATED --------------------
export const useCarCareServiceCenters = (params = {}, enabled = true) => {
  return usePaginatedResource(
    CAR_CARE_SERVICE_CENTER_QUERY_KEY,
    getCarCareServiceCenters,
    params,
    enabled
  )
}

// -------------------- FETCH SINGLE ITEM --------------------
export const useCarCareServiceCenter = (id, enabled = true) => {
  return useResourceItem(
    CAR_CARE_SERVICE_CENTER_QUERY_KEY,
    getCarCareServiceCenter,
    id,
    enabled
  )
}

// -------------------- CREATE --------------------
export const useCreateCarCareServiceCenter = () => {
  return useCreateResource(
    createCarCareServiceCenter,
    CAR_CARE_SERVICE_CENTER_QUERY_KEY
  )
}

// -------------------- EDIT --------------------
export const useEditCarCareServiceCenter = () => {
  return useEditResource(
    updateCarCareServiceCenter,
    CAR_CARE_SERVICE_CENTER_QUERY_KEY
  )
}

// -------------------- DELETE (Soft Delete) --------------------
export const useDeleteCarCareServiceCenter = () => {
  return useDeleteResource(
    deleteCarCareServiceCenter,
    CAR_CARE_SERVICE_CENTER_QUERY_KEY
  )
}
